module.exports = __webpack_public_path__ + "img/mess-02.9f4bf1f7.svg";